import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  SelectChangeEvent,
} from '@mui/material';
import { FC } from 'react';
import {
  Nullable,
  IssueTypeField,
  JiraTicket,
  FieldSchemaType,
} from 'common-types';

const DynamicField: FC<React.PropsWithChildren<DynamicFieldProps>> = ({
  field,
  onDynamicFieldChange,
  jiraTicketFields,
  validationObject,
}) => {
  switch (field.schema?.type) {
    case FieldSchemaType.Array:
    case FieldSchemaType.Option: {
      return (
        <FormControl required={true} size='small' fullWidth>
          <InputLabel id={field.key}>{field.name}</InputLabel>
          <Select
            required={true}
            value={jiraTicketFields?.dynamicFields?.[field.key] || ''}
            name={field.key}
            size='small'
            labelId={field.key}
            label={field.name}
            renderValue={v => v.value}
            error={!!validationObject?.[field.key]}
            onChange={onDynamicFieldChange}>
            {field.allowedValues &&
              field.allowedValues.map(allowedValue => (
                //@ts-ignore - necessary to load object into value
                <MenuItem key={allowedValue.id} value={allowedValue}>
                  {allowedValue.value}
                </MenuItem>
              ))}
          </Select>
          <FormHelperText error filled>
            {validationObject?.[field.key]
              ? validationObject?.[field.key].message
              : ''}
          </FormHelperText>
        </FormControl>
      );
    }

    default:
      return null;
  }
};

export interface DynamicFieldProps {
  field: IssueTypeField;
  validationObject: Nullable<{
    [key: string]: {
      message: string;
    };
  }>;
  jiraTicketFields: JiraTicket;
  onDynamicFieldChange: (
    e: SelectChangeEvent<{
      value: string;
      id: string;
    }>,
  ) => void;
}

export default DynamicField;
